export default "__VITE_ASSET__BCrV4hGb__"